import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class GrnItemReceivedQtyResponse extends GlobalResponseObject{
    data?: number;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: number){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

